export enum TYPES_SIDE_CERTIFICATE {
  HYBRID,
  PIPE,
  WAVE,
  ALL
}

export const typeOrderOptions = [
  {value: TYPES_SIDE_CERTIFICATE.HYBRID, label: 'Гибридные'},
  {value: TYPES_SIDE_CERTIFICATE.PIPE, label: 'Труба'},
  {value: TYPES_SIDE_CERTIFICATE.WAVE, label: 'Волна'},
  {value: TYPES_SIDE_CERTIFICATE.ALL, label: 'Все'},
]

export const statusActiveCertificateOptions = [
  {value: 0, label: 'Все'},
  {value: 1, label: 'Да'},
  {value: 2, label: 'Нет'},
]

export const sourceOfSales = [
  {value: 0, label: 'Все'},
  {value: 1, label: 'Не определено'},
  {value: 2, label: 'Сайт электронный'},
  {value: 3, label: 'Сайт с доставкой'},
  {value: 4, label: 'Визит'},
  {value: 5, label: 'Токи продаж'},
]

export enum TYPES_CERTIFICATE {
  VALID,
  EXPIRED,
  USED,
  ACTIVATED,
  RETURN,
  ALL,
}

export const defaultFiltersCertificate = {
  nameCertificate: null,
  side:null,
  status: null,
  is_active: null,
  party: undefined,
  search: null,
  created_at: null,
  date_sale: null
}

export const SIDE_CERTIFICATE_TITLE:any =  {
  [TYPES_SIDE_CERTIFICATE.HYBRID]: 'Гибридный',
  [TYPES_SIDE_CERTIFICATE.PIPE]: 'Труба',
  [TYPES_SIDE_CERTIFICATE.WAVE]: 'Волна'
}



export const NAME_TYPES_CERTIFICATE: any = {
  VALID: {
    title: 'Действителен',
    class: 'valid'
  },
  EXPIRED: {
    title: 'Просрочен',
    class: 'expired'
  },
  USED: {
    title: 'Израсходован',
    class: 'used'
  },
  ACTIVATED: {
    title: 'Активирован',
    class: 'activated'
  },
  PAY_LOAD: {
    title: 'Ждем оплату',
    class: 'pay-load'
  },
  RETURN: {
    title: 'Возвращен',
    class: 'used'
  },
  ALL: {
    title: 'Все',
    class: 'pay-load'
  },
};

export const statusCertificateOptions = [
  {value: TYPES_CERTIFICATE.VALID, label: NAME_TYPES_CERTIFICATE.VALID.title},
  {value: TYPES_CERTIFICATE.EXPIRED, label: NAME_TYPES_CERTIFICATE.EXPIRED.title},
  {value: TYPES_CERTIFICATE.USED, label: NAME_TYPES_CERTIFICATE.USED.title},
  {value: TYPES_CERTIFICATE.ACTIVATED, label: NAME_TYPES_CERTIFICATE.ACTIVATED.title},
  {value: TYPES_CERTIFICATE.RETURN, label: NAME_TYPES_CERTIFICATE.RETURN.title},
  {value: TYPES_CERTIFICATE.ALL, label: NAME_TYPES_CERTIFICATE.ALL.title},
]